import React, { useState } from "react";
import Button from "./Button";
import AlertBox from "./AlertBox";
import { DateTime } from "luxon";
import { useStateContext } from "../contexts/ContextProvider";
import { apiUpdateLeaseArchive } from "../services/apiService";

const initialErrorState = {
  reasonEnded: "",
  reasonEndedNotes: "",
  dateEnded: "",
};

const EndLeaseModal = (props) => {
  const { lease, deleteActiveLease } = props;
  const { setLeaseArchives, handleModal, alert, handleAlert } =
    useStateContext();
  const [error, setError] = useState(initialErrorState);

  const [archive, setArchive] = useState({
    reasonEnded: "--",
    reasonEndedNotes: "",
    dateEnded: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setArchive((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleArchive = async () => {
    archive.dateEnded = DateTime.now().toISO();
    const response = await apiUpdateLeaseArchive(lease.uuid, archive); // archive is created when lease is created
    if (response.hasError) {
      console.log("Archive Lease Error!");
      console.log(response.error.response.statusText);
    } else {
      setLeaseArchives((prevState) => [...prevState, response.data]);
      deleteActiveLease(lease.id);
      handleModal("endLease");
    }
  };

  const hasErrors = () => {
    if (archive.reasonEnded === "--") {
      activateError("reasonEnded");
      return true;
    } else if (
      archive.reasonEnded === "other" &&
      archive.reasonEndedNotes === ""
    ) {
      activateError("reasonEndedNotes");
      return true;
    } else {
      return false;
    }
  };

  const activateError = (item) => {
    setError((prevState) => ({
      ...prevState,
      [item]: "animate-shake text-red-600 border-red-600",
    }));
    setTimeout(() => {
      setError((prevState) => ({
        ...prevState,
        [item]: "",
      }));
    }, 500);
    clearTimeout();
  };

  return (
    <div className="w-screen h-screen fixed top-0 left-0 right-0 bg-white mt-20 z-10">
      {alert.archiveLease && (
        <AlertBox
          alertType="archiveLease"
          handleAlert={handleAlert}
          alertFunc={handleArchive}
        />
      )}
      <form className="grid justify-items-center mt-10">
        <label
          className={`grid ${error.reasonEnded} ${error.reasonEndedNotes}`}
        >
          What is the reason for ending this lease?
          <select
            id="reason-ended"
            name="reasonEnded"
            className={`w-full border-gray-400 rounded-md border-1 mt-5 ${error.reasonEnded}`}
            value={archive.reasonEnded}
            onChange={handleChange}
          >
            <option disabled>--</option>
            <option value="as agreed">Lease Ended As Agreed</option>
            <option value="abandoned">Lease Was Abandoned</option>
            <option value="evicted">Tenant Was Evicted</option>
            <option value="other">Other</option>
          </select>
        </label>
        {archive.reasonEnded === "other" && (
          <div className="w-full mt-5 px-16">
            {/* <div>Please provide further details.</div> */}
            <textarea
              id="reason-ended-notes"
              name="reasonEndedNotes"
              type="textarea"
              maxLength={150}
              placeholder="Please provide further details..."
              value={archive.reasonEndedNotes}
              onChange={handleChange}
              className={`w-full h-40 border-gray-400 rounded-md border-1 p-3 ${error.reasonEndedNotes}`}
            />
          </div>
        )}
      </form>
      <div className="flex justify-center fixed bottom-0 w-full my-10">
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Close"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => handleModal("endLease")}
        />
        <Button
          background="bg-snappily-orange"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Archive"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => {
            if (hasErrors()) {
              console.log("errors!");
              return;
            } else {
              handleAlert("archiveLease");
            }
          }}
        />
      </div>
    </div>
  );
};

export default EndLeaseModal;
